// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Jn3dE","largestCol":"styles_largestCol__EgA1o","smallestCol":"styles_smallestCol__1Stba"};